import propTypes from 'prop-types'
import Icon from './icon'

export default function CategoryPill({ category, locale, variant = undefined }) {
  const className = variant
    ? `category-pill category-pill-${variant} text-nowrap`
    : 'category-pill text-nowrap'

  return (
    <span className={className}>
      <Icon name={category?.icon} /> {category[`${locale}_name`]}
    </span>
  )
}

CategoryPill.propTypes = {
  category: propTypes.object.isRequired,
  locale: propTypes.string.isRequired, // more efficient to pass in instead of calling mult times here
  variant: propTypes.oneOf(['cause']),
}
